// client/src/helpers.ts

export type Option<T> = { kind: 'none' } | { kind: 'some'; value: T }

export function Option<T>(value: T): Option<T> {
  if (!value) return { kind: 'none' }

  return {
    kind: 'some',
    value: value
  }
}

export function stripHTMLTags(html: string): string {
  const el: HTMLDivElement = document.createElement('div')
  el.innerHTML = decodeHTMLEntities(html);
  return el.innerText
}

export function toRelativeUrl(url: string): string {
  let relative: string = url.replace(`${window.location.protocol}//`, '')
  return relative.indexOf('/') > 0 ? relative.substr(relative.indexOf('/')) : relative
}

export function decodeHTMLEntities(html: string): string {
  let output: Element = document.createElement('div')
  output.innerHTML = html
  return output.textContent
}

export type ViewPortSize = 'mobile' | 'tablet' | 'desktop'

export function resizeImage(url: string, width: number, height: number): string {
  // Implement resize
  return url
}

export type gtmHash<T> = { [key: string]: T }

type gtmType = {
  event?: string
  category?: string
  label?: string
  action?: string
}

export function gtmPush(data: gtmType) {
  let defaultData: gtmHash<string> = {
    event: 'event.conneqt',
    category: '',
    action: '',
    label: window.location.pathname
  }

  if (window.dataLayer) {
    window.dataLayer.push({ ...defaultData, ...data });
  } else {
    console.log({ ...defaultData, ...data });
  }
}

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/random
export function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min); //The maximum is exclusive and the minimum is inclusive
}


// WEBPACK FOOTER //
// ./Client/helpers.ts